<button type="button" class="bz-copy-button" [attr.aria-label]="label()" (click)="copy()">
  <bz-icon [icon]="justCopied() ? checkIcon : copyIcon" size="md" />
</button>
